(function() {
  var $d086c8f90b929f73$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("mobile-nav")) return;
    const lockScroll = () => document.documentElement.classList.add("overflow-hidden");
    const unlockScroll = () => document.documentElement.classList.remove("overflow-hidden");
    const SUBMENU_TRANSITION = "opacity 0.25s ease";
    customElements.define("mobile-nav", class MobileNav extends HTMLElement {
      connectedCallback() {
        this.triggers = this.querySelectorAll("[data-mobile-nav-trigger]");
        this.menus = this.querySelectorAll("[data-mobile-nav-menu]");
        this.activeMenu = null;
        Object.assign(this.style, {
          transform: "translateY(-100%)",
          transition: "transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
          visibility: "hidden"
        });
        this.menus.forEach(menu => {
          Object.assign(menu.style, {
            opacity: "0",
            visibility: "hidden",
            transition: SUBMENU_TRANSITION
          });
        });
        this.openBtn = document.querySelector("[data-mobile-nav-open]");
        if (this.openBtn) this.openBtn.addEventListener("click", () => this._toggleNav());
        this.triggers.forEach((trigger, i) => {
          trigger.addEventListener("click", () => this._openMenu(this.menus[i]));
        });
        this.querySelectorAll("[data-mobile-nav-back]").forEach(back => {
          back.addEventListener("click", () => this._closeMenu(back.closest("[data-mobile-nav-menu]")));
        });
        this._initBackBar();
      }
      _initBackBar() {
        this.searchBorder = document.querySelector("[data-header-search]");
        if (!this.searchBorder) return;
        this.searchContent = this.searchBorder.firstElementChild;
        this.backBar = document.querySelector("[data-mobile-nav-back-bar]");
        if (!this.backBar) return;
        this.searchBorder.appendChild(this.backBar);
        this.backBar.addEventListener("click", () => this._closeMenu(this.activeMenu));
      }
      _showBackBar(title) {
        if (!this.searchBorder) return;
        this.searchContent.style.display = "none";
        this.backBar.style.display = "flex";
        this.backBar.querySelector("[data-mobile-nav-back-title]").textContent = title;
      }
      _hideBackBar() {
        if (!this.searchBorder) return;
        this.backBar.style.display = "none";
        this.searchContent.style.display = "";
      }
      _openNav() {
        this.style.visibility = "visible";
        this.offsetHeight;
        this.style.transform = "translateY(0%)";
        this.classList.add("is-active");
        if (this.openBtn) this.openBtn.classList.add("is-active");
        lockScroll();
        window.dispatchEvent(new CustomEvent("mobile-nav:toggle", {
          detail: {
            open: true
          }
        }));
      }
      _closeNav() {
        this.style.transform = "translateY(-100%)";
        this.classList.remove("is-active");
        if (this.openBtn) this.openBtn.classList.remove("is-active");
        this._hideBackBar();
        unlockScroll();
        window.dispatchEvent(new CustomEvent("mobile-nav:toggle", {
          detail: {
            open: false
          }
        }));
        const onEnd = () => {
          this.style.visibility = "hidden";
          this.menus.forEach(menu => {
            menu.style.opacity = "0";
            menu.style.visibility = "hidden";
          });
          this.activeMenu = null;
          this.removeEventListener("transitionend", onEnd);
        };
        this.addEventListener("transitionend", onEnd);
      }
      _toggleNav() {
        const isOpen = this.style.transform === "translateY(0%)";
        isOpen ? this._closeNav() : this._openNav();
      }
      _openMenu(menu) {
        this.activeMenu = menu;
        menu.style.visibility = "visible";
        menu.offsetHeight;
        menu.style.opacity = "1";
        this._showBackBar(menu.dataset.mobileNavTitle || "");
      }
      _closeMenu(menu) {
        if (!menu) return;
        menu.style.opacity = "0";
        this._hideBackBar();
        this.activeMenu = null;
        const onEnd = () => {
          menu.style.visibility = "hidden";
          menu.removeEventListener("transitionend", onEnd);
        };
        menu.addEventListener("transitionend", onEnd);
      }
    });
  })();
})();